function sliderPeriodicos() {
	var element = document.getElementById('swipePeriodicos'),
		controles = document.getElementsByClassName('periodicos__controles')[0],
		prevBtn = controles.getElementsByClassName('periodicos__controles-prev')[0],
		nextBtn = controles.getElementsByClassName('periodicos__controles-next')[0];
	window.mySwipe = new Swipe(element, {
		startSlide: 0, 
		auto: 3000,
		draggable: true,
		autoRestart: false,
		continuous: true,
		disableScroll: true,
		stopPropagation: true,
		callback: function (index, element) {},
		transitionEnd: function (index, element) {}
	});

	// using jQuery
	// window.mySwipe = $('#mySwipe').Swipe().data('Swipe');

	prevBtn.onclick = mySwipe.prev;
	nextBtn.onclick = mySwipe.next;
}

function sliderRevistas() {
	var element = document.getElementById('swipeRevistas'),
		controles = document.getElementsByClassName('revistas__controles')[0],
		prevBtn = controles.getElementsByClassName('revistas__controles-prev')[0],
		nextBtn = controles.getElementsByClassName('revistas__controles-next')[0];

	window.mySwipe = new Swipe(element, {
		startSlide: 0,
		auto: 3000,
		draggable: true,
		autoRestart: false,
		continuous: true,
		disableScroll: true,
		stopPropagation: true,
		callback: function (index, element) {},
		transitionEnd: function (index, element) {}
	});

	// using jQuery
	// window.mySwipe = $('#mySwipe').Swipe().data('Swipe');

	prevBtn.onclick = mySwipe.prev;
	nextBtn.onclick = mySwipe.next;

}

function carouselRevistas() { 
	var carouselDefault = new PureJSCarousel({

		carousel: '#carouselRevistas',
		slide: '.carousel__item',

		// slides the items one by one
		oneByOne: true,

		// animation speed
		speed: 1000,
 
		// animation delay
		delay: 0,

		// easing effect
		effect: 'linear',

		// autopaly options
		autoplay: false,
		autoplayDelay: 1000,
		autoplayStartDelay: 3000,
		autoplayDirection: 'next',

		// infinite looping
		infinite: true,
	});

}
